import { render, staticRenderFns } from "./TrajectoryDataTable.vue?vue&type=template&id=480beb5c&scoped=true"
import script from "./TrajectoryDataTable.vue?vue&type=script&lang=js"
export * from "./TrajectoryDataTable.vue?vue&type=script&lang=js"
import style0 from "./TrajectoryDataTable.vue?vue&type=style&index=0&id=480beb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480beb5c",
  null
  
)

export default component.exports